// Re-export surface. Screens import everything from "../src/icons" —
// the categorized files behind this index keep each domain (credential
// vs. product UI) small, with shared IconProps in icon-props.ts.

export type { IconProps } from "./icon-props";

export {
  TruckIcon,
  AnchorIcon,
  DroneIcon,
  HouseIcon,
  CertificateIcon,
  SnowflakeIcon,
  DumbbellIcon,
  PillIcon,
  LotusIcon,
  BuildingIcon,
  StampIcon,
  UmbrellaIcon,
  LedgerIcon,
  getCredentialIcon,
} from "./credential-icons";

export {
  MicrophoneIcon,
  SparkleIcon,
  ChevronRightIcon,
  SearchIcon,
  CloseIcon,
  ShieldIcon,
} from "./ui-icons";
